<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import { ref, computed, Ref } from 'vue'
import { assemble } from '@/composables/charts/influx-charts/chart-builders/ChartFactory'
import CustomNodeEditMenu, { EditNodeDialogPayload } from '@/components/wysiwyg-components/nodes/CustomNodeEditMenu.vue'
import GenericCustomDialog from '@/components/GenericCustomDialog.vue'
import { SerializedChartType } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import ChartCreatorDialog from '@/components/charts/chart-creator/ChartCreatorDialog.vue'

const props = defineProps(nodeViewProps)

const dialog = ref(false)
const serializedChart: Ref<SerializedChartType | null | undefined> = ref(props.node.attrs.serialized)

const chartComponent = computed(() => assemble(props.node.attrs.serialized))

const saveChart = (nodeProps: EditNodeDialogPayload) => {
  nodeProps.onUpdate({ serialized: serializedChart.value })
  nodeProps.onSave()
  nodeProps.updateEditNodeDialog(false)
}
</script>

<template>
  <node-view-wrapper
    as="div"
    class="d-inline-block"
  >
    <CustomNodeEditMenu
      :selected="props.selected"
      :variant-parameters="node.attrs"
      current-variant="inline-chart"
      :variants="[
        { tag: 'inline-chart', label: 'Inline', icon: 'mdi-text' },
        { tag: 'chart-block', label: 'Block', icon: 'mdi-chart-line' },
      ]"
      :node-props="props"
      :editor-focused="props.editor.isFocused"
    >
      <template #element="nodeProps">
        <v-container
          class="ma-0 pa-0"
          fluid
        >
          <v-chip
            v-bind="nodeProps"
            class="px-4"
            prepend-icon="mdi-chart-line"
            append-icon="mdi-open-in-new"
            @click="dialog = true"
          >
            {{ serializedChart?.title ?? $t('wysiwyg.chart.inline_chart') }}
          </v-chip>
        </v-container>
      </template>
      <template #nodeEditor="nodeProps">
        <ChartCreatorDialog
          v-model:chart="serializedChart"
          v-model:show-chart-dialog="nodeProps.editNodeDialog"
          is-edit-mode
          hide-actions
          @update:show-chart-dialog="value => nodeProps.updateEditNodeDialog(value ?? false)"
          @save="saveChart(nodeProps)"
        />
      </template>
    </CustomNodeEditMenu>
    <generic-custom-dialog
      v-model="dialog"
      max-width="100%"
    >
      <template #body>
        <component :is="chartComponent" />
      </template>
    </generic-custom-dialog>
  </node-view-wrapper>
</template>

<style scoped></style>
